export default class HighlightingLabel {
  id = '';
  name = '';
  color = '';
  backgroundColor = '';
  accountId = '';

  constructor(data = null) {
    if (data == null || !data.Id) {
      return;
    }

    this.id = data.Id;
    this.name = data.Name;
    this.color = data.Color;
    this.backgroundColor = data.BackgroundColor;
    this.accountId = data.AccountId;
  }

  getStyle() {
    if (!this.color || !this.backgroundColor) {
      return '';
    }

    return `color: ${this.color}; background: ${this.backgroundColor};`;
  }
}